var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27788 10.6382H2.50659C2.991 13.634 5.366 16.009 8.35709 16.4887V15.7174C5.78457 15.2518 3.74818 13.2154 3.27788 10.6382Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7173 8.36198H16.4886C16.0042 5.36618 13.6339 2.99118 10.6428 2.51147V3.28276C13.2154 3.74836 15.247 5.78475 15.7173 8.36198Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6382 15.722V16.4933C13.634 16.0089 16.0043 13.6339 16.484 10.6428H15.7127C15.2471 13.2154 13.2154 15.2517 10.6382 15.722Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36198 3.27788V2.50659C5.36618 2.991 2.99118 5.366 2.51147 8.35709H3.28276C3.74836 5.78457 5.78475 3.74818 8.36198 3.27788Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49984 13.0837C9.29291 13.0837 9.1189 13.253 9.1189 13.4647V18.6191C9.1189 18.8261 9.2882 19.0001 9.49984 19.0001C9.71147 19.0001 9.88078 18.8308 9.88078 18.6191V13.4647C9.88078 13.2483 9.70677 13.0837 9.49984 13.0837Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91634 9.50008C5.91634 9.29315 5.74704 9.11914 5.5354 9.11914H0.380941C0.17401 9.11914 0 9.28845 0 9.50008C0 9.70701 0.169307 9.88102 0.380941 9.88102H5.5354C5.74704 9.88102 5.91634 9.70701 5.91634 9.50008Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88078 5.5354V0.380941C9.88078 0.17401 9.71147 0 9.49984 0C9.2882 0 9.1189 0.169307 9.1189 0.380941V5.5354C9.1189 5.74704 9.2882 5.91634 9.49984 5.91634C9.71147 5.91634 9.88078 5.75174 9.88078 5.5354Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.619 9.11914H13.4598C13.2529 9.11914 13.0789 9.28845 13.0789 9.50008C13.0789 9.70701 13.2482 9.88102 13.4598 9.88102H18.619C18.8259 9.88102 18.9999 9.71172 18.9999 9.50008C18.9999 9.29315 18.8306 9.11914 18.619 9.11914Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49979 12.002C10.8816 12.002 12.0018 10.8818 12.0018 9.50003C12.0018 8.11822 10.8816 6.99805 9.49979 6.99805C8.11798 6.99805 6.9978 8.11822 6.9978 9.50003C6.9978 10.8818 8.11798 12.002 9.49979 12.002Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HomeIcon.fad61a09a39eb1faf74a217f9f366b7c.svg";